var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 23",
    style: {
      enableBackground: "new 0 0 22 23"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,10.1c0-0.1-0.1-0.2-0.2-0.2l-8.3-6.6C11.2,3.1,11,3,10.8,3s-0.4,0.1-0.5,0.2L2.4,9.8 c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3v9.5c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h5c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5v-5.4h4.7v5.4c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h5c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5v-9.5C19.8,10.3,19.8,10.2,19.7,10.1z M18.4,19.1h-0.1h-3.5v-5.4c0-0.2-0.1-0.4-0.2-0.5 c-0.1-0.1-0.3-0.2-0.5-0.2H7.9c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5v5.4H3.7v-8.5l7.2-5.9l7.5,5.9V19.1z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.26a5f960.svg";
export { ForwardRef as ReactComponent };